var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "swiperBlock", staticClass: "slider-wrapper" },
    [
      _c(
        "swiper-container",
        {
          key: _vm.keySwiper,
          ref: "customGallery",
          attrs: {
            init: "false",
            lazy: "true",
            "pagination-dynamic-bullets": _vm.dynamicBullets ? "true" : null,
          },
          on: {
            swiperslidechange: _vm.handleSlideChange,
            swiperinit: _vm.onSwiperInitMain,
            swiperactiveindexchange: _vm.onUpdate,
            swiperobserverupdate: _vm.onSwiperUpdate,
          },
        },
        [
          _vm.photos.length < 1 ? _vm._t("default") : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.photos, function (photo, index) {
            return _vm.photos.length > 0
              ? _c("swiper-slide", { key: index, attrs: { lazy: "true" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "default",
                              undefined,
                              $event.key,
                              undefined
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.showGallery()
                        },
                      },
                    },
                    [
                      index == 0
                        ? _c("img", {
                            staticClass: "swiper-lazy",
                            attrs: {
                              src: photo.src,
                              width: photo.width,
                              height: photo.height,
                              loading: "lazy",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      index > 0 && _vm.activeIndex == index
                        ? _c("img", {
                            ref: "lazyImage",
                            refInFor: true,
                            staticClass: "swiper-lazy",
                            attrs: {
                              src: photo.src,
                              width: photo.width,
                              height: photo.height,
                              loading: "lazy",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e()
          }),
        ],
        2
      ),
      _vm._v(" "),
      this.countSlides > 1
        ? _c("div", { staticClass: "images-controls" }, [
            _c(
              "button",
              {
                staticClass: "images-controls__btn gallery__prev-btn",
                on: { click: _vm.prevFull },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "14",
                      viewBox: "0 0 18 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M7.13 13.3387L8.12 12.3487L3.45669 7.6875L17.25 7.6875V6.3125L3.45669 6.3125L8.11931 1.65125L7.12931 0.661246L1.28556 6.505L0.813936 7L1.28625 7.495L7.13 13.3387Z",
                        fill: "#005AA3",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "images-controls__btn gallery__next-btn",
                on: { click: _vm.nextFull },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "14",
                      viewBox: "0 0 18 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.87 0.661255L9.88 1.65125L14.5433 6.3125H0.75V7.6875H14.5433L9.88069 12.3488L10.8707 13.3388L16.7144 7.495L17.1861 7L16.7138 6.505L10.87 0.661255Z",
                        fill: "#005AA3",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }